import LoaderWithData from './LoaderWithData';

export default LoaderWithData;
